export enum DrawerMenuItemType {
  MARQUIS,
  PATTERN,
  COLOR,
  MARQUIS_COAT, // Don't know what else to call it...
  PROFILE,
}
